// assets/event-thankyou.js
(function () {
  function init(root) {
    if (!root) return;
    var seconds = parseInt(root.getAttribute('data-delay') || '10', 10);
    var target = root.getAttribute('data-target') || '/pages/event-kiosk';
    var counter = root.querySelector('[data-countdown]');
    var remaining = seconds;

    function tick() {
      if (counter) counter.textContent = remaining;
      if (remaining <= 0) {
        window.location.href = target;
      } else {
        remaining -= 1;
        setTimeout(tick, 1000);
      }
    }
    tick();
  }
  document.addEventListener('DOMContentLoaded', function () {
    init(document.getElementById('jc-thanks'));
  });
})();
